import React from 'react'
import { Button, Card, Grid, Typography, Tabs, Tab, } from '@material-ui/core'
import { useStyles } from './styles'
import ReactSelect from 'react-select';
import ReactAudioPlayer from 'react-audio-player';
import Backdrop from '../../../../components/Modal/Backdrop';
import Modal from '../../../../components/Modal/Modal'
import { TabContext, TabPanel } from '@material-ui/lab';
import RecordAudio from './RecordAudio';
import UploadAudio from './UploadAudio';
import { BiPlusCircle } from 'react-icons/bi'
import AddNumber from './AddNumber';
import axiosInstance from '../../../../environment/axiosInstance'
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { makeStyles, } from '@material-ui/core';
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
toast.configure()

const muiTheme = createMuiTheme({});
const useStyleses = makeStyles(
    (theme: any) => {
        return {
            root: {
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                },
            },
            loopIcon: {
                color: '#4D72F8',
                '&.selected': {
                    color: '#0921a9'
                },
                '&:hover': {
                    color: '#4D72F8'
                },
                [theme.breakpoints.down('sm')]: {
                    display: 'none'
                }
            },
            playIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            pauseIcon: {
                color: '#4D72F8',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeSlider: {
                color: '#4D72F8'
            },
            progressTime: {
                color: '#6b6b6d'
            },
            mainSlider: {
                color: '#4D72F8',
                '& .MuiSlider-rail': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-track': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-thumb': {
                    color: '#4D72F8'
                }
            }
        }
    });


function ForwardNumber(props: any) {
    const classes = useStyles()
    const [value, setValue] = React.useState("2");
    const [shouldRecord, setShouldRecord] = React.useState(false)
    const [addNumberModal, setAddNumberModal] = React.useState(false);
    const [frwNumber, setFrwNumber] = React.useState([])
    const handleChange = (event: React.ChangeEvent<{}>, newValue: any) => {
        setValue(newValue);
    };
    const handlePopupModalAdd = () => {
        setShouldRecord(!shouldRecord)
        // setopenModalAdd(!openModalAdd)
    }

    const handlePopupModalNumber = () => {
        setAddNumberModal(!addNumberModal)
    }

    const handleLoadMetadata = (meta: any) => {
        const { duration } = meta.target;
        const styles = makeStyles({

        })
        // console.log(duration);
    }

    React.useEffect(() => {
        const numbers: any = []
        if (props.closeHoursData) {
            props.closeHoursData.closeHours?.ForwardNumbers?.map((item: any) => {
                var myObj = {
                    label: item.phoneNumber,
                    value: item._id,
                    isSelected: item.isSelected
                }
                numbers.push(myObj)
            })
            setFrwNumber(numbers)
        }
    }, [props.closeHoursData])

    const selectedNum = frwNumber.findIndex((option: any) => {
        if (option.isSelected === true) {
            return option
        }
    })

    //update number
    const onChangePhoneNumberDropDown = (e: any) => {
        const id = e.value
        const data = {
            phoneNumberId: id
        }
        axiosInstance.patch(`/departments/${props.deptId}/close-hours/forward-number`, data).then((res: any) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: toast.POSITION.TOP_RIGHT, autoClose: 1000
                })
                props.getClosedHours()
            }

        }).catch((err) => {
            //send err
        })

    }

    return (
        <>
            {
                shouldRecord && (
                    <div>
                        <Backdrop handlePopupModal={handlePopupModalAdd} />
                        <Modal title="Record Audio" handlePopupModal={handlePopupModalAdd}>
                            <div className={classes.divSpacing}>
                                <Tabs
                                    value={value}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    className={classes.tabs}
                                    onChange={handleChange}
                                    id="editOpenHourGreetingsTab"
                                    style={{}}
                                >
                                    {/* <Tab
                                        label="Record Audio"
                                        value="1"
                                        className={value === "1" ? classes.tabActive : classes.tab}
                                    /> */}
                                    <Tab
                                        label="Upload Audio"
                                        value="2"
                                        className={value === "2" ? classes.tabActive : classes.tab}
                                    />

                                </Tabs>
                                <TabContext value={value}>
                                    <TabPanel value="1">
                                        <RecordAudio
                                            closeHoursData={props.closeHoursData}
                                            getClosedHours={props.getClosedHours}
                                            deptId={props.deptId}
                                            loading={props.loading}
                                        />
                                    </TabPanel>
                                    <TabPanel value="2">
                                        <UploadAudio
                                            closeHoursData={props.closeHoursData}
                                            getClosedHours={props.getClosedHours}
                                            deptId={props.deptId}
                                            loading={props.loading}
                                        />
                                    </TabPanel>
                                </TabContext>

                            </div>
                        </Modal>
                    </div>
                )
            }
            {
                addNumberModal && (
                    <div>
                        <Backdrop handlePopupModal={handlePopupModalNumber} />
                        <Modal title="Add Number" handlePopupModal={handlePopupModalNumber}>
                            <div className="add_user_popup" style={{ width: "500px", padding: '10px 40px 10px 30px' }}>
                                <AddNumber deptId={props.deptId} handlePopupModal={handlePopupModalNumber} getClosedHours={props.getClosedHours} />
                                {/* <AddNumber closeHoursData={props.closeHoursData} handlePopupModal={handlePopupModalNumber} /> */}
                            </div>
                        </Modal>
                    </div>
                )
            }
            <div className={classes.divPadding}>
                <Card className={classes.cardStyle}>
                    <Grid container spacing={6}>
                        <Grid item md={4} xs={8} sm={6}>
                            <Typography className={classes.title}>Enter Number</Typography>
                            <ReactSelect
                                options={frwNumber}
                                value={frwNumber[selectedNum]}
                                onChange={onChangePhoneNumberDropDown}
                                placeholder="Select Number"
                            />
                        </Grid>
                        <Grid item md={4} xs={4} sm={4}>
                            <Typography className={classes.title}>.</Typography>
                            <div
                                className={classes.button}
                                style={{ border: '1px solid lightgrey' }}
                                onClick={handlePopupModalNumber}
                            >
                                <BiPlusCircle />
                            </div>
                        </Grid>
                    </Grid>



                    <div style={{ marginTop: '20px' }}>
                        <Card className={classes.cardStyle}>
                            <Grid container spacing={3}>
                                <Grid item md={8} sm={9} xs={12}>
                                    <ThemeProvider theme={muiTheme}>
                                        <ReactAudioPlayer
                                            controls
                                            // className={classes.audioPlayer}
                                            onLoadedMetadata={handleLoadMetadata}
                                            src={props.frwNumberPath !== "" ? props.frwNumberPath : ""}
                                            className={classes.audioPlayers}
                                        />
                                    </ThemeProvider>

                                    <div style={{ textAlign: 'left', marginTop: '-16px' }}>
                                        <span className={classes.filename}>{props.frwNumberPathName}</span>
                                    </div>
                                </Grid>
                                <Grid item md={4} sm={3} xs={12}>
                                    <Button className={classes.editBtn} onClick={handlePopupModalAdd}>
                                        Edit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                    </div>
                </Card>
            </div>
        </>
    )
}

export default ForwardNumber